import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import CardHeader from '@mui/material/CardHeader';
import Card from '@mui/material/Card';
import ListItemText from '@mui/material/ListItemText';

import { alpha, useTheme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function CallAction({ title, subheader, list, ...other }) {

  const theme = useTheme();

  const handleClick = () => {
    const subject = encodeURIComponent("Plus de 250 apprenants par an.");
    const body = encodeURIComponent(
      "Bonjour l’équipe Postgrad,\n\nSeriez-vous disponible prochainement pour convenir d’une offre sur mesure pour mon organisme de formation ?\n\nÀ bientôt !"
    );
  
    window.location.href = `mailto:contact@postgrad.fr?subject=${subject}&body=${body}`;
  };

  const defaultStyles = {
    borderTop: `solid 1px ${alpha(theme.palette.grey[500], 0.16)}`,
    borderBottom: `solid 1px ${alpha(theme.palette.grey[500], 0.16)}`,
    '&:first-of-type': {
      borderTopLeftRadius: 16,
      borderBottomLeftRadius: 16,
      borderLeft: `solid 1px ${alpha(theme.palette.grey[500], 0.16)}`,
    },
    '&:last-of-type': {
      borderTopRightRadius: 16,
      borderBottomRightRadius: 16,
      borderRight: `solid 1px ${alpha(theme.palette.grey[500], 0.16)}`,
    },
  };

  return (


      <Stack 
        spacing={3} 
        sx={{
          mt:5,
          mx:"auto",
          width: 350,
          borderRadius: 2,
          [`&:hover`]: {
            backgroundColor: 'background.paper',
            boxShadow: theme.customShadows.z20,
            transition: theme.transitions.create(['background-color', 'box-shadow'], {
              duration: theme.transitions.duration.shortest,
            }),
            '&:hover': {
              backgroundColor: 'background.paper',
              boxShadow: theme.customShadows.z20,
            },
          },
        }}
      >

        <Card sx={{px:2, py:3, cursor: 'pointer' }} onClick={()=>handleClick()}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar
              variant="rounded"
              sx={{ width: 48, height: 48, flexShrink: 0 }}
            />

            <ListItemText
              // primary={<Link sx={{ color: 'text.primary', typography: 'subtitle2' }}>name</Link>}
              primary={<> Plus de 250 apprenants par an ?</>}
              secondary={
                <>
                  <Box component="span" sx={{ color: 'text.secondary' }}>
                    Cliquer ici pour nous contacter
                  </Box>
                </>
              }
              primaryTypographyProps={{
                noWrap: true,
              }}
              secondaryTypographyProps={{
                mt: 0.5,
              }}
            />
          </Stack>
        </Card>
      </Stack>
  );
}

CallAction.propTypes = {
  list: PropTypes.array,
  subheader: PropTypes.string,
  title: PropTypes.string,
};


